import * as React from "react";

class ButtonFText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <svg
        className="buttonF-text buttonFG-text"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 433.8 139.9"
      >
        <g>
          <path
            fill="#FCFAEE"
            d="M89.94,53.129h7.832v1.746h-5.744v3.691h4.861v1.765h-4.861v4.285h5.943v1.765H89.94V53.129z"
          />
          <path
            fill="#FCFAEE"
            d="M99.983,63.752c0-2.125,1.801-3.223,5.924-3.673c-0.018-1.152-0.432-2.161-1.891-2.161
			c-1.043,0-2.016,0.469-2.861,1.009l-0.775-1.404c1.027-0.648,2.412-1.297,3.998-1.297c2.467,0,3.6,1.566,3.6,4.195v5.96h-1.691
			l-0.18-1.135h-0.055c-0.9,0.774-1.963,1.368-3.15,1.368C101.19,66.614,99.983,65.498,99.983,63.752z M105.907,63.824v-2.431
			c-2.934,0.359-3.924,1.098-3.924,2.214c0,0.973,0.666,1.369,1.547,1.369C104.395,64.977,105.096,64.563,105.907,63.824z"
          />
          <path
            fill="#FCFAEE"
            d="M109.866,65.246l0.971-1.332c0.883,0.702,1.748,1.134,2.811,1.134c1.188,0,1.746-0.576,1.746-1.332
			c0-0.9-1.117-1.296-2.197-1.711c-1.314-0.504-2.826-1.206-2.826-2.881c0-1.656,1.332-2.898,3.51-2.898
			c1.334,0,2.414,0.54,3.225,1.17l-0.973,1.279c-0.686-0.505-1.387-0.864-2.215-0.864c-1.08,0-1.584,0.54-1.584,1.224
			c0,0.847,1.025,1.171,2.105,1.566c1.387,0.522,2.918,1.135,2.918,3.007c0,1.657-1.314,3.007-3.764,3.007
			C112.223,66.614,110.819,66.038,109.866,65.246z"
          />
          <path
            fill="#FCFAEE"
            d="M118.846,61.447c0-3.313,2.215-5.222,4.664-5.222s4.664,1.908,4.664,5.222
			c0,3.277-2.215,5.167-4.664,5.167S118.846,64.725,118.846,61.447z M126.049,61.447c0-2.106-0.973-3.511-2.539-3.511
			c-1.549,0-2.521,1.404-2.521,3.511c0,2.089,0.973,3.475,2.521,3.475C125.077,64.922,126.049,63.536,126.049,61.447z"
          />
          <path
            fill="#FCFAEE"
            d="M130.6,56.478h1.693l0.162,1.368h0.053c0.92-0.882,1.928-1.62,3.277-1.62
			c2.107,0,3.043,1.404,3.043,3.925v6.23h-2.07v-5.978c0-1.711-0.504-2.396-1.674-2.396c-0.918,0-1.549,0.469-2.432,1.351v7.022
			H130.6V56.478z"
          />
          <path
            fill="#FCFAEE"
            d="M147.377,55.577h-6.373v-1.332h2.809c-0.199-0.648-0.648-1.675-1.045-2.413l1.404-0.504
			c0.451,0.756,0.918,1.729,1.135,2.377l-1.387,0.54h3.457V55.577z M146.891,65.48c0.541-0.973,0.9-2.484,1.117-3.728l1.17,0.343
			c-0.217,1.368-0.559,3.007-1.17,4.015l-1.117-0.468v1.188h-4.016v0.756h-1.404v-6.05h5.42V65.48z M146.963,58.008h-5.473v-1.314
			h5.473V58.008z M141.491,59.089h5.473v1.314h-5.473V59.089z M145.469,62.869h-2.594v2.611h2.594V62.869z M153.139,53.362
			c-0.359,3.169-1.26,5.834-4.592,7.364c-0.18-0.378-0.594-0.936-0.953-1.206c1.494-0.63,2.43-1.477,3.006-2.521
			c-0.684-0.702-1.746-1.621-2.574-2.305l0.9-0.9c0.684,0.54,1.566,1.261,2.25,1.854c0.217-0.72,0.342-1.477,0.451-2.287h-3.602
			v-1.404h8.895c0,0,0,0.45-0.035,0.667c-0.182,4.501-0.361,6.157-0.828,6.733c-0.344,0.378-0.686,0.522-1.207,0.595
			c-0.451,0.054-1.242,0.035-2.053,0c-0.035-0.414-0.197-1.026-0.449-1.44c0.756,0.071,1.475,0.071,1.764,0.071
			c0.27,0,0.432-0.036,0.594-0.197c0.252-0.343,0.451-1.657,0.594-5.024H153.139z M153.463,66.11c0.541,0,0.648-0.306,0.703-2.305
			c0.305,0.234,0.918,0.469,1.314,0.559c-0.162,2.448-0.559,3.061-1.873,3.061h-2.18c-1.566,0-1.926-0.432-1.926-1.854v-4.177h1.439
			v4.159c0,0.468,0.092,0.558,0.686,0.558H153.463z M151.987,60.007c0.738,0.811,1.584,1.891,1.963,2.593l-1.08,0.774
			c-0.342-0.757-1.17-1.891-1.891-2.719L151.987,60.007z M156.092,61.015c0.666,1.207,1.332,2.773,1.584,3.764l-1.277,0.486
			c-0.217-0.99-0.828-2.611-1.477-3.836L156.092,61.015z"
          />
          <path
            fill="#FCFAEE"
            d="M165.846,65.57c-1.387,0.883-3.619,1.765-5.385,2.232c-0.27-0.306-0.791-0.846-1.152-1.152
			c1.801-0.45,3.998-1.314,5.115-2.034L165.846,65.57z M175.209,64.437h-15.846V63.05h2.467v-7.994h4.285
			c0.055-0.307,0.107-0.631,0.18-0.973h-6.463V52.66h6.662c0.072-0.485,0.107-0.99,0.143-1.404l1.766,0.162
			c-0.072,0.414-0.145,0.828-0.217,1.242h6.572v1.423h-6.824c-0.072,0.342-0.145,0.666-0.18,0.973h5.023v7.994h2.432V64.437z
			 M163.434,56.172v0.99h7.67v-0.99H163.434z M171.104,58.188h-7.67v0.864h7.67V58.188z M163.434,60.061v0.9h7.67v-0.9H163.434z
			 M163.434,63.05h7.67v-1.063h-7.67V63.05z M169.79,64.526c1.998,0.594,4.23,1.458,5.527,2.106l-1.35,1.134
			c-1.225-0.666-3.242-1.512-5.223-2.143L169.79,64.526z"
          />
          <path
            fill="#FCFAEE"
            d="M182.639,60.871l0.396,1.477c-1.891,0.9-3.906,1.836-5.473,2.538l-0.668-1.674
			c0.648-0.234,1.477-0.559,2.396-0.937V57.09h-2.053v-1.584h2.053v-3.998h1.566v3.998h1.818v1.584h-1.818v4.537L182.639,60.871z
			 M190.833,65.931c0.99,0,1.17-0.45,1.314-2.413c0.377,0.252,1.025,0.522,1.477,0.612c-0.234,2.484-0.738,3.295-2.684,3.295h-4.141
			c-2.215,0-2.846-0.558-2.846-2.719v-5.203l-1.242,0.54l-0.631-1.495l1.873-0.792v-4.771h1.584v4.105l2.018-0.847v-4.951h1.566
			v4.285l2.412-1.026l1.242,0.414l-0.072,0.271c-0.143,2.503-0.414,5.798-0.863,7.851l-1.369-0.378
			c0.271-1.549,0.469-4.052,0.559-6.248l-1.908,0.828v6.464h-1.566v-5.798l-2.018,0.864v5.906c0,1.008,0.199,1.206,1.352,1.206
			H190.833z"
          />
          <path
            fill="#FCFAEE"
            d="M199.596,61.825c-0.451,0.09-0.973,0.18-1.514,0.234v1.225h1.135v1.08h-1.135v1.044l1.404-0.162
			l0.018,1.171l-4.266,0.54l-0.162-1.242c0.504-0.036,1.098-0.091,1.729-0.162v-1.188h-1.225v-1.08h1.225v-1.117
			c-0.451,0.036-0.865,0.036-1.262,0.036c-0.035-0.27-0.162-0.666-0.287-0.954c1.242-0.09,2.791-0.234,3.727-0.432L199.596,61.825z
			 M201.395,53.362v14.44h-1.529v-7.67c-1.676,0.126-3.313,0.271-4.609,0.342l-0.145-1.332l1.027-0.054v-5.727h-0.992V52.03h7.131
			v1.332H201.395z M199.866,53.362h-2.232v1.117h2.232V53.362z M199.866,55.56h-2.232v1.099h2.232V55.56z M197.633,58.998
			c0.701-0.035,1.477-0.09,2.232-0.144v-1.116h-2.232V58.998z M201.432,66.272c0.576-0.792,1.098-2.106,1.387-3.079l1.133,0.45
			c-0.305,1.063-0.791,2.449-1.404,3.35L201.432,66.272z M211.461,61.861h-9.418v-1.423h9.418V61.861z M205.59,55.182
			c0.055-0.343,0.109-0.721,0.182-1.116h-3.477v-1.314h3.674c0.055-0.469,0.125-0.955,0.162-1.387l1.439,0.072
			c-0.053,0.414-0.107,0.864-0.18,1.314h3.818v1.314h-4.033c-0.055,0.396-0.127,0.773-0.182,1.116h3.908v4.339h-8.301v-4.339H205.59
			z M205.069,56.405h-1.188v1.891h1.188V56.405z M207.842,66.255c0.449,0,0.539-0.181,0.594-1.549
			c0.287,0.216,0.863,0.414,1.26,0.504c-0.145,1.854-0.539,2.323-1.691,2.323h-2.035c-1.494,0-1.855-0.396-1.855-1.729v-2.593h1.404
			v2.593c0,0.378,0.092,0.45,0.613,0.45H207.842z M206.186,61.915c0.809,0.738,1.656,1.837,2.016,2.557l-1.152,0.667
			c-0.359-0.757-1.225-1.909-1.945-2.665L206.186,61.915z M207.301,56.405h-1.242v1.891h1.242V56.405z M208.292,58.296h1.297v-1.891
			h-1.297V58.296z M209.75,62.834c0.918,1.008,1.691,2.395,1.98,3.385l-1.26,0.576c-0.234-0.99-0.99-2.431-1.873-3.439
			L209.75,62.834z"
          />
          <path
            fill="#FCFAEE"
            d="M227.174,66.003c0.611,0,0.721-0.307,0.793-2.287c0.377,0.288,1.08,0.559,1.512,0.666
			c-0.18,2.521-0.631,3.151-2.16,3.151h-2.539c-1.838,0-2.27-0.486-2.27-2.143v-4.033h-2.826c-0.252,3.601-1.152,5.527-5.707,6.464
			c-0.145-0.433-0.576-1.08-0.883-1.423c4.016-0.72,4.682-2.106,4.879-5.041h-4.645v-1.566h15.861v1.566h-4.986v4.033
			c0,0.54,0.107,0.612,0.791,0.612H227.174z M215.417,57.414h-1.674v-4.178h6.752c-0.199-0.54-0.486-1.152-0.756-1.638l1.691-0.505
			c0.396,0.648,0.811,1.477,1.063,2.143h6.248v4.178h-1.729v-2.575h-11.596V57.414z M216.479,58.026v-1.53h9.488v1.53H216.479z"
          />
          <path
            fill="#FCFAEE"
            d="M236.405,55.506c-0.414,0.828-0.936,1.656-1.494,2.448v9.885h-1.584v-7.922
			c-0.469,0.521-0.973,0.99-1.459,1.404c-0.145-0.342-0.629-1.171-0.918-1.513c1.494-1.17,3.043-2.989,3.979-4.808L236.405,55.506z
			 M236.045,51.832c-1.008,1.549-2.594,3.241-4.051,4.34c-0.18-0.343-0.613-0.919-0.883-1.225c1.279-0.937,2.701-2.449,3.422-3.673
			L236.045,51.832z M246.002,60.889c-0.703,1.692-1.836,3.062-3.223,4.105c1.35,0.648,2.844,1.099,4.5,1.387
			c-0.342,0.342-0.791,1.026-1.008,1.458c-1.873-0.378-3.529-1.008-4.986-1.854c-1.531,0.883-3.295,1.494-5.096,1.873
			c-0.162-0.396-0.523-1.081-0.811-1.423c1.566-0.288,3.098-0.738,4.447-1.404c-0.594-0.45-1.135-0.954-1.656-1.494
			c-0.414,0.414-0.846,0.756-1.279,1.08c-0.234-0.324-0.791-0.954-1.135-1.242c0.486-0.288,0.973-0.666,1.424-1.081
			c-0.324-0.449-0.631-0.918-0.9-1.44l1.367-0.449c0.182,0.323,0.344,0.611,0.559,0.899c0.559-0.611,1.045-1.296,1.477-1.998
			c-2.287,0.144-2.773,0.216-3.15,0.36c-0.055-0.307-0.307-1.117-0.486-1.549c0.541-0.072,1.152-0.378,1.998-0.847
			c0.379-0.197,1.1-0.63,1.98-1.206c-2.322,0.108-2.809,0.198-3.078,0.307c-0.09-0.343-0.359-1.152-0.559-1.603
			c0.361-0.072,0.738-0.307,1.207-0.612c0.449-0.324,1.998-1.513,3.043-2.773l1.656,0.738c-0.99,0.973-2.107,1.927-3.223,2.683
			l2.844-0.071c0.756-0.559,1.514-1.188,2.197-1.818l1.531,0.846c-1.945,1.639-4.053,3.043-6.123,4.178l4.771-0.271
			c-0.324-0.45-0.666-0.9-0.99-1.278l1.314-0.685c0.99,1.188,2.232,2.845,2.826,3.89l-1.385,0.792
			c-0.199-0.396-0.506-0.918-0.883-1.458l-3.691,0.252c-0.217,0.432-0.469,0.882-0.756,1.296h3.961l0.287-0.071L246.002,60.889z
			 M239.754,61.825c-0.162,0.234-0.359,0.45-0.559,0.666c0.613,0.648,1.332,1.207,2.107,1.692c1.008-0.647,1.854-1.44,2.467-2.358
			H239.754z"
          />
          <path
            fill="#FCFAEE"
            d="M250.805,62.041c1.387-0.521,2.197-1.35,2.287-2.431c-0.072,0.019-0.162,0.019-0.252,0.019
			c-0.811,0-1.512-0.505-1.512-1.44c0-0.919,0.701-1.44,1.529-1.44c1.135,0,1.729,0.882,1.729,2.25c0,1.999-1.26,3.548-3.313,4.214
			L250.805,62.041z"
          />
          <path
            fill="#FCFAEE"
            d="M274.137,54.029c-0.721,0.647-1.604,1.332-2.359,1.854c0.865,0.468,1.818,0.864,2.846,1.134
			c-0.324,0.307-0.775,0.919-1.01,1.314c-0.828-0.252-1.619-0.594-2.34-1.008v2.034c0,0.414,0.055,0.54,0.307,0.54h1.115
			c0.252,0,0.686-0.018,0.883-0.071c0.018,0.342,0.055,0.828,0.107,1.17c-0.197,0.072-0.594,0.09-0.953,0.09h-1.314
			c-1.262,0-1.514-0.504-1.514-1.746v-1.423h-2.105v0.072c0,1.206-0.361,2.646-1.945,3.583c-0.197-0.271-0.684-0.738-1.008-0.973
			v0.288h-3.674c-0.072,0.522-0.145,1.063-0.234,1.549h3.943c0,0-0.018,0.432-0.053,0.648c-0.217,2.467-0.414,3.547-0.865,4.015
			c-0.342,0.343-0.721,0.45-1.277,0.486c-0.486,0.054-1.404,0.036-2.377,0c-0.037-0.432-0.234-1.026-0.504-1.422
			c0.953,0.09,1.891,0.107,2.25,0.107c0.307,0,0.486-0.018,0.648-0.162c0.234-0.216,0.414-0.9,0.559-2.412h-3.943
			c0.234-1.099,0.504-2.755,0.648-4.088h3.385v-1.62h-2.791v-0.252c-0.613,0.306-1.242,0.576-1.855,0.792
			c-0.197-0.36-0.594-0.954-0.9-1.242c1.135-0.342,2.287-0.883,3.295-1.549c-0.504-0.45-1.242-0.972-1.854-1.351l0.953-0.899
			c0.668,0.378,1.496,0.936,2.035,1.386c0.559-0.468,1.027-1.008,1.422-1.566h-3.889v-1.332h4.771l0.27-0.055l1.063,0.505
			c-0.773,1.765-2.053,3.169-3.564,4.249h2.539v3.799c1.332-0.738,1.529-1.674,1.529-2.521v-1.351h3.746
			c-1.729-1.242-3.061-2.881-3.961-4.861l1.332-0.396c0.324,0.685,0.721,1.333,1.188,1.945c0.721-0.559,1.549-1.314,2.035-1.891
			l1.207,0.864c-0.756,0.702-1.656,1.404-2.412,1.927c0.359,0.359,0.736,0.666,1.152,0.972c0.773-0.576,1.691-1.404,2.25-1.98
			L274.137,54.029z M272.823,62.077c-0.486,1.333-1.225,2.395-2.16,3.241c0.881,0.522,1.691,1.026,2.268,1.423l-0.863,1.098
			c-0.631-0.468-1.531-1.044-2.539-1.656c-1.17,0.756-2.539,1.278-4.051,1.639c-0.145-0.378-0.469-0.919-0.738-1.225
			c1.277-0.234,2.447-0.648,3.475-1.206c-0.918-0.559-1.855-1.099-2.684-1.566l0.756-0.864h-0.629v-1.188h5.977l0.252-0.036
			L272.823,62.077z M266.467,62.96c0.898,0.485,1.943,1.044,2.951,1.638c0.559-0.485,1.045-1.025,1.441-1.638H266.467z"
          />
          <path
            fill="#FCFAEE"
            d="M282.684,63.229c-2.25,0.685-4.646,1.368-6.445,1.891l-0.414-1.603
			c0.756-0.162,1.691-0.414,2.699-0.684v-4.033h-2.16v-1.549h2.16v-3.511h-2.34v-1.549h6.176v1.549h-2.215v3.511h2.035v1.549h-2.035
			v3.583l2.305-0.648L282.684,63.229z M290.875,66.236c0.379,0,0.451-0.27,0.506-2.088c0.322,0.27,0.99,0.521,1.404,0.63
			c-0.145,2.305-0.541,2.898-1.711,2.898h-1.566c-1.441,0-1.783-0.468-1.783-1.962v-3.8h-1.477c-0.324,2.881-1.225,4.88-4.879,5.996
			c-0.162-0.396-0.594-1.063-0.936-1.368c3.223-0.847,3.906-2.377,4.176-4.628h-1.477v-9.902h8.553v9.902h-2.357v3.781
			c0,0.486,0.07,0.54,0.449,0.54H290.875z M284.7,54.894h5.33v-1.495h-5.33V54.894z M284.7,57.702h5.33v-1.513h-5.33V57.702z
			 M284.7,60.511h5.33v-1.513h-5.33V60.511z"
          />
          <path
            fill="#FCFAEE"
            d="M301.188,59.215c-0.846,0-1.422-0.055-1.801-0.234c-1.277,0.45-2.592,0.811-3.889,1.116
			c-0.199-0.324-0.613-0.9-0.9-1.188c1.387-0.252,2.791-0.576,4.105-1.008c-0.018-0.126-0.018-0.271-0.018-0.396v-2.413h1.422v2.323
			c2.16-0.847,4.033-1.944,5.258-3.313l1.26,0.576c-1.225,1.369-2.936,2.467-4.826,3.35h2.846c0.703,0,0.846-0.162,0.918-1.152
			c0.324,0.198,0.883,0.396,1.279,0.468c-0.162,1.513-0.631,1.873-2.035,1.873H301.188z M296.2,55.434h-1.512V52.57h6.896
			c-0.162-0.342-0.361-0.702-0.541-1.008l1.604-0.36c0.252,0.396,0.559,0.937,0.756,1.368h6.445v2.863h-1.566v-1.549h-6.842
			c0.756,0.378,1.566,0.883,2.035,1.261l-0.918,0.9c-0.576-0.505-1.676-1.188-2.539-1.603l0.648-0.559H296.2V55.434z
			 M306.788,64.292c1.242,0.828,2.629,1.944,3.35,2.701l-1.279,0.882c-0.27-0.288-0.611-0.612-0.99-0.973
			c-4.699,0.217-9.633,0.379-12.838,0.469l-0.162-1.459c1.746-0.035,4.033-0.09,6.537-0.144v-1.477h-5.043v-3.943h5.043v-0.9h1.656
			v0.9h5.4v3.943H306.788z M295.012,57.486c0.721-0.559,1.387-1.513,1.764-2.269l1.189,0.576c-0.451,0.846-1.063,1.854-1.801,2.521
			L295.012,57.486z M301.405,63.014v-1.387H298v1.387H301.405z M303.061,61.627v1.387h3.654v-1.387H303.061z M306.301,65.606
			c-0.377-0.271-0.773-0.559-1.135-0.811l0.883-0.504h-2.988v1.423L306.301,65.606z M307.022,55.344
			c1.045,0.647,2.305,1.674,2.898,2.448l-1.242,0.774c-0.541-0.756-1.746-1.837-2.809-2.539L307.022,55.344z"
          />
          <path
            fill="#FCFAEE"
            d="M327.2,53.183c-0.557,1.423-1.439,2.593-2.502,3.565c1.207,0.72,2.611,1.278,4.141,1.584
			c-0.324,0.307-0.773,0.937-0.99,1.314c-1.619-0.378-3.078-1.063-4.338-1.963c-1.352,0.955-2.936,1.657-4.574,2.107
			c-0.09-0.252-0.289-0.559-0.486-0.828v2.269h-2.305v3.295l1.152-0.217c-0.145-0.647-0.307-1.296-0.432-1.854l1.205-0.323
			c0.414,1.422,0.83,3.223,0.99,4.447l-1.277,0.378c-0.035-0.378-0.107-0.811-0.197-1.261c-1.873,0.396-3.764,0.792-5.295,1.099
			l-0.324-1.549c0.775-0.107,1.748-0.27,2.773-0.468v-3.547h-0.99v0.756h-1.207v-7.4h2.197V51.49h1.404v3.097h2.305v0.9
			c1.494-0.99,2.791-2.521,3.529-4.231l1.459,0.378c-0.162,0.396-0.361,0.774-0.596,1.152h3.098l0.27-0.071L327.2,53.183z
			 M313.75,59.862h1.117v-3.907h-1.117V59.862z M317.225,55.955H316v3.907h1.225V55.955z M318.45,58.477
			c1.387-0.36,2.756-0.937,3.943-1.711c-0.521-0.468-0.955-0.99-1.369-1.548c-0.467,0.504-0.99,0.972-1.494,1.332
			c-0.234-0.198-0.721-0.612-1.08-0.864V58.477z M324.284,64.31h4.016v1.279h-4.016v2.178h-1.566v-2.178h-3.727V64.31h3.727v-1.062
			h-2.826v-1.207h2.826v-1.008h-3.15v-1.225h3.15v-1.261h1.566v1.261h3.24v1.225h-3.24v1.008h2.916v1.207h-2.916V64.31z
			 M321.997,54.065l-0.072,0.09c0.414,0.63,0.955,1.224,1.586,1.765c0.646-0.541,1.188-1.171,1.602-1.854H321.997z"
          />
          <path
            fill="#FCFAEE"
            d="M337.153,65.192c-1.604,0.973-4.033,1.98-5.943,2.593c-0.252-0.36-0.738-0.937-1.098-1.278
			c1.908-0.522,4.34-1.549,5.582-2.395L337.153,65.192z M346.245,63.968h-15.936V62.42h3.17v-7.652h-2.646v-1.531h2.646v-1.926
			h1.656v1.926h6.23v-1.926h1.691v1.926h2.756v1.531h-2.756v7.652h3.188V63.968z M335.135,54.768v1.512h6.23v-1.512H335.135z
			 M335.135,59.322h6.23v-1.62h-6.23V59.322z M335.135,62.42h6.23v-1.693h-6.23V62.42z M340.59,64.256
			c2.053,0.702,4.34,1.692,5.709,2.395l-1.549,1.099c-1.225-0.72-3.295-1.711-5.348-2.448L340.59,64.256z"
          />
          <path
            fill="#FCFAEE"
            d="M105.317,77.88v1.225h-3.098l-0.145,1.512H91.776l0.199-1.512h-2.846V77.88h3.008l0.18-1.44h10.154
			l-0.145,1.44H105.317z M99.807,86.954c1.836,0.469,3.709,1.045,4.934,1.459l-1.135,1.063c-1.26-0.486-3.385-1.188-5.438-1.747
			l0.701-0.774h-3.654l1.063,0.721c-1.477,0.792-3.926,1.477-5.941,1.782c-0.199-0.306-0.613-0.828-0.9-1.152
			c1.746-0.234,3.906-0.811,5.148-1.351h-3.078v-5.689h11.488v5.689H99.807z M91.2,77.357h-1.512v-2.971h6.734
			c-0.199-0.433-0.451-0.864-0.666-1.225l1.439-0.414c0.379,0.469,0.738,1.116,0.973,1.639h6.572v2.971h-1.584v-1.639H91.2V77.357z
			 M93.127,82.867h8.174v-0.685h-8.174V82.867z M93.127,84.434h8.174v-0.702h-8.174V84.434z M93.127,86.036h8.174v-0.72h-8.174
			V86.036z M93.379,79.716h2.934c0.037-0.252,0.072-0.504,0.092-0.773h-2.936L93.379,79.716z M93.684,77.357l-0.09,0.685h2.918
			l0.053-0.685H93.684z M100.635,79.716l0.072-0.773h-2.898c-0.037,0.27-0.072,0.521-0.092,0.773H100.635z M100.833,77.357h-2.861
			l-0.072,0.685h2.881L100.833,77.357z"
          />
          <path
            fill="#FCFAEE"
            d="M123.208,86.954v1.711h-15.988v-1.711h5.203v-9.038h-4.771v-1.657h3.873
			c-0.307-0.828-0.938-1.962-1.531-2.79l1.494-0.559c0.703,0.9,1.422,2.143,1.711,2.971l-0.883,0.378h5.203l-0.359-0.126
			c0.611-0.882,1.35-2.269,1.746-3.276l1.855,0.521c-0.576,1.009-1.225,2.071-1.801,2.881h3.816v1.657h-4.861v9.038H123.208z
			 M109.92,79.464c0.846,1.765,1.512,4.052,1.711,5.564l-1.621,0.432c-0.145-1.53-0.791-3.835-1.584-5.6L109.92,79.464z
			 M114.098,86.954h2.143v-9.038h-2.143V86.954z M118.528,85.028c0.666-1.495,1.457-3.926,1.836-5.708l1.801,0.414
			c-0.631,1.98-1.441,4.249-2.125,5.726L118.528,85.028z"
          />
          <path
            fill="#FCFAEE"
            d="M135.286,75.81c-0.379,0.611-0.758,1.242-1.189,1.854v11.721h-1.818v-9.452
			c-1.729,1.927-3.816,3.637-6.141,4.861c-0.27-0.45-0.791-1.135-1.152-1.494c3.422-1.675,6.375-4.556,8.104-7.49h-7.598v-1.711
			h15.412v1.711H135.286z M135.428,78.546c2.018,1.351,4.754,3.385,6.068,4.771l-1.404,1.296c-1.207-1.386-3.871-3.528-5.924-4.987
			L135.428,78.546z"
          />
          <path
            fill="#FCFAEE"
            d="M152.204,87.44c0.559,0.054,1.189,0.072,1.838,0.072c0.791,0.018,4.393,0,5.455-0.019
			c-0.234,0.379-0.486,1.117-0.576,1.585h-4.969c-3.439,0-5.727-0.504-7.203-2.791c-0.666,1.297-1.566,2.358-2.664,3.151
			c-0.252-0.307-0.883-0.919-1.242-1.188c1.836-1.171,2.953-3.151,3.402-5.654l1.674,0.234c-0.125,0.595-0.27,1.171-0.449,1.692
			c0.648,1.459,1.656,2.251,3.061,2.629v-5.041h-7.201v-1.477H159.1v1.477h-6.896v1.71h5.727v1.459h-5.727V87.44z M157.227,79.59
			H145.11v-6.05h12.117V79.59z M155.536,74.783h-8.805v1.206h8.805V74.783z M155.536,77.159h-8.805v1.207h8.805V77.159z"
          />
          <path
            fill="#FCFAEE"
            d="M166.315,73.433c-0.469,1.332-1.08,2.665-1.764,3.907v12.027h-1.586v-9.435
			c-0.432,0.594-0.863,1.152-1.332,1.656c-0.143-0.414-0.629-1.314-0.918-1.692c1.621-1.692,3.133-4.321,4.033-6.95L166.315,73.433z
			 M176.631,81.967c-0.576,0.342-1.223,0.702-1.871,1.009c0.559,1.71,1.566,3.295,2.844,4.087c-0.342,0.288-0.828,0.864-1.043,1.242
			c-1.369-0.972-2.395-2.772-3.008-4.753c-0.234,0.107-0.449,0.197-0.631,0.288c0.668,1.962,0.414,4.033-0.395,4.807
			c-0.486,0.522-0.99,0.667-1.676,0.685c-0.342,0-0.738-0.018-1.152-0.036c-0.018-0.396-0.143-1.008-0.377-1.422
			c0.467,0.054,0.881,0.071,1.188,0.071c0.379,0,0.648-0.054,0.865-0.378c0.342-0.324,0.521-1.188,0.414-2.196
			c-1.531,1.351-3.691,2.574-5.564,3.205c-0.197-0.343-0.631-0.883-0.955-1.152c2.234-0.666,4.844-2.017,6.195-3.439
			c-0.09-0.252-0.217-0.504-0.342-0.774c-1.334,1.099-3.277,2.161-4.844,2.719c-0.199-0.306-0.613-0.792-0.9-1.062
			c1.746-0.486,3.961-1.566,5.131-2.593c-0.197-0.253-0.396-0.486-0.648-0.702c-1.17,0.81-2.557,1.53-3.744,1.962
			c-0.18-0.324-0.594-0.792-0.883-1.063c1.297-0.396,2.826-1.08,4.016-1.836h-2.611V77.97c-0.27,0.216-0.521,0.433-0.811,0.648
			c-0.215-0.343-0.701-0.864-1.025-1.099c1.908-1.332,3.258-3.15,3.996-4.627l1.549,0.288c-0.162,0.324-0.342,0.647-0.539,0.972
			h3.006l0.324-0.09l0.973,0.721c-0.396,0.63-0.883,1.278-1.369,1.854h3.602v3.997h-5.313l-0.18,0.162
			c0.686,0.54,1.189,1.206,1.586,1.927c1.061-0.541,2.285-1.279,3.041-1.819L176.631,81.967z M168.961,75.431
			c-0.324,0.396-0.629,0.811-1.008,1.207h3.061c0.307-0.343,0.648-0.793,0.9-1.207H168.961z M168.116,79.393h2.521v-1.495h-2.521
			V79.393z M174.795,77.897h-2.646v1.495h2.646V77.897z"
          />
          <path
            fill="#FCFAEE"
            d="M193.606,75.269V89.35h-1.764v-0.9h-9.111v0.972h-1.674V75.269h4.537
			c0.252-0.773,0.467-1.71,0.594-2.412l1.998,0.233c-0.287,0.757-0.576,1.531-0.883,2.179H193.606z M182.731,76.871v2.305h9.111
			v-2.305H182.731z M182.731,80.725v2.305h9.111v-2.305H182.731z M191.842,86.9v-2.322h-9.111V86.9H191.842z"
          />
          <path
            fill="#FCFAEE"
            d="M209.356,87.368c1.854,0,2.123-0.468,2.322-3.15c0.469,0.27,1.225,0.558,1.711,0.666
			c-0.342,3.277-0.99,4.159-4.033,4.159h-6.338c-3.063,0-4.053-0.54-4.053-2.791v-6.554h10.443v-4.069h-10.676v-1.71h12.441v8.498
			h-1.766v-1.08h-8.715v4.897c0,0.954,0.361,1.134,2.287,1.134H209.356z"
          />
          <path
            fill="#FCFAEE"
            d="M218.352,83.443V79.23c-0.701,1.296-1.566,2.467-2.447,3.223c-0.254-0.378-0.758-0.9-1.1-1.188
			c1.262-0.9,2.521-2.629,3.277-4.339h-2.846v-1.423h3.115v-2.574h1.586v2.574h2.699v1.423h-2.699v0.864
			c0.684,0.414,2.467,1.71,2.934,2.053l-0.9,1.368c-0.432-0.45-1.295-1.242-2.033-1.873v4.088L218.352,83.443z M215.004,87.692
			c0.701-0.954,1.295-2.448,1.639-3.69l1.475,0.594c-0.359,1.242-0.936,2.845-1.602,3.854L215.004,87.692z M225.266,87.53
			c0.848,0,0.973-0.252,1.08-2.053c0.361,0.271,1.045,0.505,1.514,0.612c-0.234,2.377-0.703,2.936-2.467,2.936h-3.512
			c-2.16,0-2.719-0.45-2.719-2.035v-2.683h1.656v2.665c0,0.486,0.18,0.558,1.207,0.558H225.266z M222.764,82.939
			c0.811,0.756,1.908,1.818,2.467,2.467l-1.225,1.026c-0.504-0.667-1.584-1.783-2.395-2.593L222.764,82.939z M230.489,83.228h-7.113
			v-9.417h7.113V83.228z M228.885,75.161h-3.979v1.368h3.979V75.161z M228.885,77.808h-3.979v1.404h3.979V77.808z M228.885,80.473
			h-3.979v1.422h3.979V80.473z M229.227,83.731c0.738,1.116,1.729,2.646,2.197,3.565l-1.549,0.792
			c-0.432-0.937-1.387-2.521-2.105-3.673L229.227,83.731z"
          />
          <path
            fill="#FCFAEE"
            d="M238.315,73.433c-0.469,1.332-1.08,2.665-1.764,3.907v12.027h-1.586v-9.435
			c-0.432,0.594-0.863,1.152-1.332,1.656c-0.143-0.414-0.629-1.314-0.918-1.692c1.621-1.692,3.133-4.321,4.033-6.95L238.315,73.433z
			 M248.631,81.967c-0.576,0.342-1.223,0.702-1.871,1.009c0.559,1.71,1.566,3.295,2.844,4.087c-0.342,0.288-0.828,0.864-1.043,1.242
			c-1.369-0.972-2.395-2.772-3.008-4.753c-0.234,0.107-0.449,0.197-0.631,0.288c0.668,1.962,0.414,4.033-0.395,4.807
			c-0.486,0.522-0.99,0.667-1.676,0.685c-0.342,0-0.738-0.018-1.152-0.036c-0.018-0.396-0.143-1.008-0.377-1.422
			c0.467,0.054,0.881,0.071,1.188,0.071c0.379,0,0.648-0.054,0.865-0.378c0.342-0.324,0.521-1.188,0.414-2.196
			c-1.531,1.351-3.691,2.574-5.564,3.205c-0.197-0.343-0.631-0.883-0.955-1.152c2.234-0.666,4.844-2.017,6.195-3.439
			c-0.09-0.252-0.217-0.504-0.342-0.774c-1.334,1.099-3.277,2.161-4.844,2.719c-0.199-0.306-0.613-0.792-0.9-1.062
			c1.746-0.486,3.961-1.566,5.131-2.593c-0.197-0.253-0.396-0.486-0.648-0.702c-1.17,0.81-2.557,1.53-3.744,1.962
			c-0.18-0.324-0.594-0.792-0.883-1.063c1.297-0.396,2.826-1.08,4.016-1.836h-2.611V77.97c-0.27,0.216-0.521,0.433-0.811,0.648
			c-0.215-0.343-0.701-0.864-1.025-1.099c1.908-1.332,3.258-3.15,3.996-4.627l1.549,0.288c-0.162,0.324-0.342,0.647-0.539,0.972
			h3.006l0.324-0.09l0.973,0.721c-0.396,0.63-0.883,1.278-1.369,1.854h3.602v3.997h-5.313l-0.18,0.162
			c0.686,0.54,1.189,1.206,1.586,1.927c1.061-0.541,2.285-1.279,3.041-1.819L248.631,81.967z M240.961,75.431
			c-0.324,0.396-0.629,0.811-1.008,1.207h3.061c0.307-0.343,0.648-0.793,0.9-1.207H240.961z M240.116,79.393h2.521v-1.495h-2.521
			V79.393z M246.795,77.897h-2.646v1.495h2.646V77.897z"
          />
          <path
            fill="#FCFAEE"
            d="M256.567,82.471l0.396,1.477c-1.891,0.9-3.906,1.837-5.473,2.539l-0.668-1.675
			c0.648-0.233,1.477-0.558,2.396-0.936V78.69h-2.053v-1.585h2.053v-3.997h1.566v3.997h1.818v1.585h-1.818v4.537L256.567,82.471z
			 M264.76,87.53c0.99,0,1.17-0.45,1.314-2.412c0.377,0.252,1.025,0.521,1.477,0.612c-0.234,2.484-0.738,3.295-2.684,3.295h-4.141
			c-2.215,0-2.846-0.559-2.846-2.719v-5.204l-1.242,0.54l-0.631-1.494l1.873-0.792v-4.771h1.584v4.105l2.018-0.847v-4.951h1.566
			v4.285l2.412-1.026l1.242,0.414l-0.072,0.27c-0.143,2.503-0.414,5.798-0.863,7.851l-1.369-0.378
			c0.271-1.549,0.469-4.051,0.559-6.248l-1.908,0.828v6.464h-1.566v-5.797l-2.018,0.864v5.905c0,1.009,0.199,1.206,1.352,1.206
			H264.76z"
          />
          <path
            fill="#FCFAEE"
            d="M278.6,74.009c-0.629,1.513-1.387,2.917-2.287,4.195h1.873v1.458h-3.006
			c-0.469,0.54-0.973,1.063-1.477,1.549h3.762v7.868h-1.584v-0.738h-3.564v0.99h-1.514v-5.852c-0.395,0.234-0.791,0.486-1.223,0.72
			c-0.162-0.359-0.686-1.044-0.973-1.368c1.656-0.811,3.188-1.891,4.482-3.169h-4.051v-1.458h3.367v-1.891h-2.574v-1.44h2.574
			v-1.854h1.549v1.854h2.07v0.937c0.396-0.703,0.756-1.459,1.063-2.251L278.6,74.009z M275.881,82.562h-3.564v1.476h3.564V82.562z
			 M275.881,86.973v-1.621h-3.564v1.621H275.881z M274.405,78.204c0.486-0.595,0.9-1.225,1.314-1.891h-1.764v1.891H274.405z
			 M285.551,74.585c-0.703,1.692-1.604,3.745-2.414,5.365c1.729,1.603,2.125,3.007,2.125,4.231c0.018,1.206-0.27,2.07-0.936,2.521
			c-0.324,0.216-0.756,0.343-1.225,0.414c-0.469,0.055-1.063,0.055-1.639,0.019c-0.018-0.45-0.197-1.188-0.449-1.621
			c0.521,0.055,0.99,0.055,1.35,0.036c0.307-0.018,0.594-0.072,0.793-0.198c0.377-0.216,0.504-0.684,0.504-1.332
			c0-1.063-0.504-2.395-2.197-3.871c0.666-1.404,1.404-3.277,1.908-4.699h-2.863v13.954h-1.639V73.883h5.205l0.252-0.072
			L285.551,74.585z"
          />
          <path
            fill="#FCFAEE"
            d="M296.204,87.44c0.559,0.054,1.189,0.072,1.838,0.072c0.791,0.018,4.393,0,5.455-0.019
			c-0.234,0.379-0.486,1.117-0.576,1.585h-4.969c-3.439,0-5.727-0.504-7.203-2.791c-0.666,1.297-1.566,2.358-2.664,3.151
			c-0.252-0.307-0.883-0.919-1.242-1.188c1.836-1.171,2.953-3.151,3.402-5.654l1.674,0.234c-0.125,0.595-0.27,1.171-0.449,1.692
			c0.648,1.459,1.656,2.251,3.061,2.629v-5.041h-7.201v-1.477H303.1v1.477h-6.896v1.71h5.727v1.459h-5.727V87.44z M301.227,79.59
			H289.11v-6.05h12.117V79.59z M299.536,74.783h-8.805v1.206h8.805V74.783z M299.536,77.159h-8.805v1.207h8.805V77.159z"
          />
          <path
            fill="#FCFAEE"
            d="M310.028,84.29c-1.549,0.773-3.205,1.548-4.574,2.143l-0.631-1.621
			c0.541-0.198,1.189-0.432,1.91-0.738V78.69h-1.586v-1.585h1.586V73.09h1.584v4.016h1.512v1.585h-1.512v4.735
			c0.449-0.181,0.9-0.379,1.35-0.576L310.028,84.29z M321.208,84.632c-0.809,0.666-1.818,1.314-2.699,1.818
			c0.811,0.595,1.781,1.026,2.881,1.297c-0.342,0.288-0.793,0.918-1.01,1.332c-2.412-0.721-4.141-2.269-5.166-4.411
			c-0.504,0.324-1.045,0.63-1.656,0.9v1.854l2.465-0.738c-0.018,0.378,0.02,0.972,0.055,1.278c-3.133,1.044-3.637,1.242-3.926,1.458
			c-0.09-0.342-0.432-0.954-0.646-1.224c0.252-0.198,0.576-0.576,0.576-1.333v-0.684c-0.596,0.216-1.244,0.414-1.91,0.611
			c-0.18-0.359-0.594-0.936-0.918-1.206c2.611-0.576,4.609-1.458,5.727-2.358l1.656,0.378c-0.107,0.09-0.197,0.18-0.307,0.271
			c0.289,0.611,0.686,1.206,1.17,1.71c0.883-0.54,1.891-1.261,2.539-1.854c-0.811-0.306-2.07-0.738-3.043-1.008l0.559-0.9
			c1.045,0.27,2.502,0.702,3.295,1.026l-0.521,0.99l-0.072-0.036L321.208,84.632z M321.208,75.377h-11.162v-1.314h4.734
			c-0.107-0.342-0.232-0.666-0.359-0.954l1.639-0.324c0.197,0.396,0.414,0.864,0.521,1.278h4.627V75.377z M310.333,83.012
			c0.973-0.271,2.287-0.685,3.674-1.135l0.197,1.044c-1.17,0.433-2.395,0.828-3.438,1.188L310.333,83.012z M310.891,79.986
			c1.045,0.216,2.484,0.594,3.26,0.828l-0.396,1.026c-0.773-0.27-2.197-0.702-3.26-0.954L310.891,79.986z M320.596,79.752h-9.76
			v-3.564h9.76V79.752z M313.7,77.231h-1.422v1.477h1.422V77.231z M314.834,83.102v-2.936h1.531v2.936H314.834z M316.366,77.231
			h-1.459v1.477h1.459V77.231z M320.631,80.977c-0.99,0.307-2.34,0.522-3.258,0.612l-0.289-0.882
			c0.883-0.127,2.342-0.595,3.152-0.847L320.631,80.977z M319.084,77.231h-1.494v1.477h1.494V77.231z"
          />
          <path
            fill="#FCFAEE"
            d="M332.061,72.929c-0.02,0.684-0.037,1.62-0.127,2.683c0.252,2.25,1.352,9.435,7.635,12.226
			c-0.486,0.378-0.99,0.972-1.225,1.422c-4.23-1.998-6.193-5.959-7.148-9.183c-0.9,3.385-2.809,7.022-6.877,9.273
			c-0.289-0.433-0.828-0.973-1.387-1.333c7.363-3.817,7.166-12.207,7.219-15.088H332.061z"
          />
          <path
            fill="#FCFAEE"
            d="M344.75,78.348c1.566,0,2.809,1.261,2.809,2.809c0,1.549-1.242,2.81-2.809,2.81
			c-1.549,0-2.809-1.261-2.809-2.81C341.942,79.608,343.202,78.348,344.75,78.348z M344.75,82.885c0.953,0,1.729-0.773,1.729-1.729
			c0-0.954-0.775-1.729-1.729-1.729c-0.938,0-1.729,0.774-1.729,1.729C343.022,82.111,343.813,82.885,344.75,82.885z"
          />
        </g>
      </svg>
    );
  }
}

export default ButtonFText;



// WEBPACK FOOTER //
// ./src/storyC/components/ButtonFText.tsx